import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { availableDeliveryProviders, hasExternalDeliveryProviders } from '../../services/tenant/serviceProviderConfig';
import { isPlgOnboardingProvider } from '../../services/tenant/plgOnboarding';

export default function useServiceProvider() {
  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const hasExternalDelivery = useMemo(
    () => hasExternalDeliveryProviders(availableDeliveryProviders(serviceProvider)),
    [serviceProvider],
  );

  const hasExternalAnalytics = !!serviceProvider?.has_analytics_provider;

  // Self-serve (PLG) partner onboarding: FoodAmigos-only and not-yet-applicable
  // surfaces are hidden. See services/tenant/plgOnboarding.js.
  const hasPlgOnboarding = isPlgOnboardingProvider(serviceProvider);

  return {
    hasExternalDelivery,
    hasExternalAnalytics,
    hasPlgOnboarding,
  };
}
